import {
    ContentCopy,
    ContentPaste,
    Article,
    Note,
    Description,
    Inventory,
    Category,
    Apartment,
    Language,
    EditAttributes,
    Work,
    BurstMode,
    Person,
    DeveloperBoard,
    Settings,
    Grading,
    LocalMall,
    People,
    Store,
    Payment,
    Tune,
    Factory,
    MotionPhotosAuto,
    Build,
    Quiz,
    Email,
    ArtTrack
}
    from '@mui/icons-material';

const menusData = [
    {
        icon: <ContentCopy />,
        label: 'Quản lý nội dung',
        children: [
            { icon: <Article />, label: 'Trang', url: 'page' },
            { icon: <Note />, label: 'Danh mục bài viết', url: 'post-category' },
            { icon: <Description />, label: 'Quản lý bài viết', url: 'post' },
        ],
    },

    {
        icon: <Inventory />,
        label: 'Quản lý sản phẩm',
        children: [
            { icon: <Category />, label: 'Danh mục sản phẩm', url: 'product-category' },
            { icon: <Work />, label: 'Quản lý sản phẩm', url: 'product' },
        ],
    },
    {
        icon: <Quiz />,
        label: 'Giao diện',
        children: [

            { icon: <Email />, label: 'Thông tin', url: 'options' },
            { icon: <ArtTrack />, label: 'Slider', url: 'slider' },
        ],
    },
    {
        icon: <Build />,
        label: 'Hệ thống',
        children: [
            { icon: <Person />, label: 'Người dùng', url: 'user' },
            { icon: <DeveloperBoard />, label: 'Nhóm quyền', url: 'role' },
        ],
    },
];

export default menusData